import {
  FormControl,
  FormHelperText,
  InputLabel,
  InputProps,
  OutlinedInput,
} from "@mui/material";
import { useFormikContext } from "formik";

interface Props extends InputProps {
  name: string;
  label: string;
  placeholder?: string;
  helperText?: string;
}

export default function AppInput({
  name,
  label,
  placeholder,
  helperText,
  ...props
}: Props) {
  const { handleChange, handleBlur, getFieldMeta } = useFormikContext<any>();
  const meta = getFieldMeta(name);
  const value = meta.value ?? "";
  const error = meta.error;
  const touched = meta.touched;
  const id = `${name}-helder-text`;

  return (
    <FormControl
      fullWidth
      error={touched && Boolean(error)}
      variant="outlined"
      margin="normal"
      required={props.required}
      disabled={props.disabled}
    >
      <InputLabel
        shrink
        htmlFor={name}
        sx={{
          position: "relative",
          whiteSpace: "normal",
        }}
      >
        {label}
      </InputLabel>
      <OutlinedInput
        onChange={handleChange}
        onBlur={handleBlur}
        aria-describedby={id}
        id={name}
        name={name}
        placeholder={placeholder || label}
        {...props}
        value={value}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {/* @ts-ignore */}
      {touched && !!error && <FormHelperText id={id}>{error}</FormHelperText>}
    </FormControl>
  );
}
